import React from 'react';
import { Descriptions, Tag } from 'antd';
import styled from 'styled-components';

const PreviewContainer = styled.div`
padding: 16px 0;
`;

const JsonPreview = styled.pre`
background: #f5f5f5;
padding: 16px;
border-radius: 4px;
overflow-x: auto;
font-family: monospace;
font-size: 13px;
`;

const typeLabels = {
  general: { text: 'Общий', color: 'blue' },
  operators: { text: 'Для операторов', color: 'green' },
  queues: { text: 'Для очередей', color: 'orange' },
};

function DictionaryPreview({ dictionary }) {
  if (!dictionary) return null;
  return (
    <PreviewContainer>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Название">{dictionary.name}</Descriptions.Item>
        <Descriptions.Item label="Тип">
          <Tag color={typeLabels[dictionary.type]?.color || 'default'}>
            {typeLabels[dictionary.type]?.text || dictionary.type}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Создан">
          {new Date(dictionary.createdAt).toLocaleString('ru-RU')}
        </Descriptions.Item>
        <Descriptions.Item label="Обновлен">
          {new Date(dictionary.updatedAt).toLocaleString('ru-RU')}
        </Descriptions.Item>
      </Descriptions>
      <h3 style={{ marginTop: '24px', marginBottom: '12px' }}>Содержание:</h3>
      <JsonPreview>{JSON.stringify(dictionary.content, null, 2)}</JsonPreview>
    </PreviewContainer>
  );
}

export default DictionaryPreview;
